import React from "react";
import "./Button.css";
import { NavLink } from "react-router-dom";

export default function Button({ label, route }) {
  return (
    <NavLink
      to={route}
      className={({ isActive }) => (isActive ? "active" : "inactive")}
    >
      {" "}
      {label}
    </NavLink>
  );
}
